import { GetSessionsToRescheduleEndpoint } from '@kouto/types';

const buildRescheduleSessionsUrl = (
  bookingId: string,
  {
    from,
    to,
    resourceGroupId,
  }: {
    from: string | undefined;
    to: string | undefined;
    resourceGroupId?: string;
  },
) => {
  const url = GetSessionsToRescheduleEndpoint.url({
    bookingId,
    query: {
      ...(from && { from }),
      ...(to && { to }),
      ...(resourceGroupId && { resourceGroupId }),
      allowOverbooking: 'false',
    },
  });

  return `${process.env.KOUTO_API_URL}/${url}`;
};

export default buildRescheduleSessionsUrl;
